import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { OrganizationFiltersComponent } from '../../Partials/organization-filters/organization-filters.component';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { OrganizationsFacade } from '../../../../../Facades/Organizations/organizations.facade';
import { DATE_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { OrganizationFilters } from '../../../Interfaces/organization-filters.interface';
import { OrganizationSummary } from '../../../../../Models/backoffice/organization-summary.model';

@Component({
  selector: 'app-organizations',
  standalone: true,
  imports: [
    DatePipe,
    DecimalPipe,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    OrganizationFiltersComponent,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './organizations.component.html',
  styleUrl: './organizations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationsComponent {
  private readonly _router = inject(Router);

  readonly facade = inject(OrganizationsFacade);

  readonly dateFormat = DATE_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly emptyTitleKey = computed<string>(() =>
    this.facade.hasActiveFilters()
      ? 'backoffice.organizations.list.filtered_empty.title'
      : 'backoffice.organizations.list.empty.title',
  );

  readonly emptyMessageKey = computed<string>(() =>
    this.facade.hasActiveFilters()
      ? 'backoffice.organizations.list.filtered_empty.message'
      : 'backoffice.organizations.list.empty.message',
  );

  applyFilters(filters: OrganizationFilters): void {
    this.facade.applyFilters(filters);
  }

  clearFilters(): void {
    this.facade.clearFilters();
  }

  goToPage(page: number): void {
    this.facade.goToPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }

  exportCsv(): void {
    this.facade.exportCsv();
  }

  openDetail(organization: OrganizationSummary): void {
    this._router.navigate(['/organizations', organization.id]);
  }

  openPeople(organization: OrganizationSummary): void {
    this._router.navigate(['/users'], { queryParams: { organization_id: organization.id } });
  }
}
